import { FAQDetails } from "../../../resources/modelTypes";
import { SectionComponentProps } from "../../types";
import { ThemedRichText } from "./ThemedRichText";
import { css } from "@emotion/react";
import { SmallHeadline } from "@minted/fancyclothes";
import { theme } from "@minted/minted-components";
import React, { memo } from "react";

const displayFAQStyles = {
  wrapper: css`
    margin-bottom: ${theme.spacing.x6};
  `,
};

const DisplayFAQSection = ({ section }: SectionComponentProps) => {
  const details = section.sectionDetails as FAQDetails;

  return (
    <div css={displayFAQStyles.wrapper}>
      <SmallHeadline>{details.question}</SmallHeadline>
      <ThemedRichText content={details.answer} />
    </div>
  );
};

const MemoizedDisplayFAQ = memo(DisplayFAQSection);

export { MemoizedDisplayFAQ as DisplayFAQSection };
